import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../../common-utils/libraries/axios/axios';
import USERS from '../apiUrls';
import userFields from '../../fields/userFields';

/**
 * @param responseData response.data object
 * @param responseData.name string
 * @param responseData.permissions array
 * @param response
 * @returns Mapped data object
 */
function mapResponseData(response) {
    const data = {};
    Object.keys(response).forEach(key => {
        data[key] = {
            [userFields.PROFILE_NAME.key]: response[key][userFields.PROFILE_NAME.key],
            [userFields.PROFILE_PERMISSIONS.key]: response[key][userFields.PROFILE_PERMISSIONS.key]
        };
    });
    return data;
}

const queryGetProfiles = (organizationId) => {
    return {
        queryKey: [USERS.PROFILE.queryKey, organizationId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(USERS.PROFILE.url, { organizationId: organizationId }));
            return mapResponseData(response.data);
        },
        enabled: !!organizationId
    };
};

export default queryGetProfiles;